export type Course = {
  code: string;
  title: string;
  level: "BSc" | "MSc";
  term: string;
  role: string;
  description: string;
  href: string;
  current: boolean;
};

export const courses = [
  {
    code: "Undervisning",
    title: "Kunstig intelligens, systemer og samfunn",
    level: "MSc",
    term: "Pågående",
    role: "Underviser",
    description:
      "Undervisning som kobler teknologi, kritisk refleksjon og praktisk bruk av kunstig intelligens i organisasjoner og samfunn.",
    href: "https://www.uia.no/english/about-uia/employees/perara12/",
    current: true,
  },
  {
    code: "Veiledning",
    title: "Bachelor-, master- og doktorgradsprosjekter",
    level: "BSc",
    term: "Pågående",
    role: "Veileder",
    description:
      "Veiledning innen anvendt AI, beslutningsstøtte, sikkerhet, infrastruktur og eksperimentell programvareutvikling.",
    href: "https://www.uia.no/english/about-uia/employees/perara12/",
    current: true,
  },
  {
    code: "Studentprosjekter",
    title: "Fra idé til fungerende prototype",
    level: "MSc",
    term: "Prosjekter",
    role: "Faglig veileder",
    description:
      "Prosjektarbeid der studenter bygger, tester og vurderer teknologi med både teknisk kvalitet og samfunnsmessig relevans.",
    href: "https://www.uia.no/english/about-uia/employees/perara12/",
    current: false,
  },
] satisfies Course[];
